import { render, staticRenderFns } from "./lazy-list.vue?vue&type=template&id=4ad4d9d3&scoped=true&"
import script from "./lazy-list.vue?vue&type=script&lang=js&"
export * from "./lazy-list.vue?vue&type=script&lang=js&"
import style0 from "./lazy-list.vue?vue&type=style&index=0&id=4ad4d9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad4d9d3",
  null
  
)

export default component.exports